import { useState } from 'react'
import toast from 'react-hot-toast'
import { HotToastTogglePrediction } from 'ui/components/toast'
import ToastCloseIcon from 'ui/components/svg/toast/ToastCloseIcon'

// TODO: Temporarily disabled predictions feature - re-enable when ready
export function usePredictionState() {
  const [predictionModalOpen, setPredictionModalOpen] = useState(false)

  const handlePredictionModalOpen = () => {
    // ONYXIA:7328 Temporarily disabled
    // setPredictionModalOpen(true)
    // toast.dismiss()
    // toast.success(() => <HotToastTogglePrediction enabled />, {
    //   duration: 5000,
    //   icon: <ToastCloseIcon />
    // })
  }

  const handlePredictionModalClose = (hideNotification?: boolean) => {
    setPredictionModalOpen(false)
    if (!hideNotification) {
      toast.dismiss()
      toast.success(() => <HotToastTogglePrediction />, {
        duration: 5000,
        icon: <ToastCloseIcon />
      })
    }
  }

  return {
    predictionModalOpen,
    setPredictionModalOpen,
    handlePredictionModalOpen,
    handlePredictionModalClose
  }
}
